export default __webpack_public_path__ + "static/media/ic_gmx_big.a0a74216.svg";